module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/ai43-bfd3f342aeb9482c3058aef8babebf59.jpg";